import React from 'react';
import BusinessCardForm from 'features/labs/components/BusinessCardForm';
import BusinessCardPageLayout from 'features/labs/components/BusinessCardPageLayout/BusinessCardPageLayout';

function BusinessCardPage() {
  return (
    <BusinessCardPageLayout>
      <BusinessCardForm />
    </BusinessCardPageLayout>
  );
}

export default BusinessCardPage;
